"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileFactory = void 0;
const Factory = require("factory.ts");
const Profiles_1 = require("../Profiles");
exports.userProfileFactory = Factory.Sync.makeFactory({
    id: `user-profile-${Factory.each(i => i + 1)}`,
    access: 'viewer',
    relationship: 'other',
    persona_listener_id: null,
    persona: Profiles_1.personaFactory.build()
});
